import { FC, PropsWithChildren } from 'react';

import { stack } from './Stack.styles';
import type { StackProps } from './Stack.types';

export const HStack: FC<PropsWithChildren<StackProps>> = ({ align, justify, spacing, wrap, className, children }) => (
	<div className={stack({ direction: 'row', align, justify, spacing, wrap, className })}>{children}</div>
);
